import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const KOTLogsServices = {
  getList: async ({ page = 1, pageSize = 20, searchText = "" }) => {
    try {
      const response = await apiService.get("/kotrequestlogs", {
        params: {
          Page: page,
          PageSize: pageSize,
          SearchText: searchText,
        },
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching KOT request logs:", error);
      throw error;
    }
  },

  deleteLog: async () => {
    try {
      const response = await apiService.delete("/kotrequestlogs/cleanup", {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error deleting KOT request log:", error);
      throw error;
    }
  }
};

export default KOTLogsServices;
